import { RibFeaturePrototype } from '../../../feature/prototype/rib/RibFeaturePrototype';
import { FeaturePreviewMesh } from '../FeaturePreviewMesh';
import { FeatureResultMesh } from '../FeatureResultMesh';
import { FeatureMeshObjectFactory, type FeatureMeshObjectBuildInput } from './FeatureMeshObjectFactory';

/**
 * 筋特征 mesh 对象工厂。
 *
 * 设计说明：
 * 1. 筋的正式结果与预览先由通用 FeatureResultMesh / FeaturePreviewMesh 承载，
 *    保证提交后的结果体能进入场景并显示；专属拓扑代理后续再按抽壳模式补。
 * 2. 工厂按 prototype 命中筋特征，避免 MeshManager 因缺少专属对象实现而抛错。
 */
export class RibMeshObjectFactory extends FeatureMeshObjectFactory {
    /**
     * @inheritdoc
     */
    public create(input: FeatureMeshObjectBuildInput) {
        if (!(input.context?.prototype instanceof RibFeaturePrototype)) {
            return null;
        }
        if (input.isPreview) {
            return new FeaturePreviewMesh({
                meshData: input.meshData,
                geometry: input.geometry,
                material: input.material,
            });
        }
        return new FeatureResultMesh({
            meshData: input.meshData,
            geometry: input.geometry,
            material: input.material,
        });
    }
}
